import { styled } from '../../Styles/stitches.config'

export const YoutubeContainer = styled('div', {
    position: 'relative',
    aspectRatio: 16 / 9,
})

export const StyledIframe = styled('iframe', {
    left: 0,
    position: 'absolute',
    size: '100%',
    top: 0,
})

export const StyledVideo = styled('video', {
    maxSize: '100%',
})
